import { InputGroup } from 'react-bootstrap5';

export default InputGroup;
